import React from 'react'
import './Search.css'
import { AiOutlineSearch } from "react-icons/ai";

const Search = () => {
  return (
    <div className='dtn-middle-container'>
      <input className='dt-search-field' type="text" placeholder='Search'/>
      <AiOutlineSearch id='dt-icons-search'/>
    </div>
  )
}

export default Search